import React, { useState } from "react";
import { AlertCircle, Calendar, CheckCircle2, Truck } from "lucide-react";

import { Switch } from "../../../components/ui/switch";

const sem = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
const rotulo = "text-[11px] font-semibold uppercase tracking-wide text-muted-foreground";
const campo = "mt-1 h-12 w-full rounded-lg border bg-background px-3 outline-none focus:ring-2 focus:ring-ring/40";

function CampoFornecedor({ valor, aoMudar, fornecedores }) {
  const [aberto, setAberto] = useState(false);
  const busca = sem(valor.trim());
  const sugestoes = fornecedores.filter((f) => !busca || sem(f).includes(busca)).slice(0, 8);
  const novo = valor.trim() && !fornecedores.some((f) => sem(f) === busca);
  return (
    <div className="relative">
      <label htmlFor="compra-fornecedor" className={rotulo}>Fornecedor</label>
      <div className="relative">
        <Truck className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input id="compra-fornecedor" data-e2e="campo-fornecedor" autoComplete="off" value={valor} placeholder="Digite ou escolha"
          onChange={(e) => { aoMudar(e.target.value); setAberto(true); }} onFocus={() => setAberto(true)}
          onBlur={() => setTimeout(() => setAberto(false), 150)} className={`${campo} pl-9 font-medium`} />
      </div>
      {aberto && sugestoes.length > 0 && !(sugestoes.length === 1 && sem(sugestoes[0]) === busca) && (
        <ul className="absolute z-40 mt-1 w-full max-h-60 overflow-y-auto rounded-lg border bg-popover shadow-lg">
          {sugestoes.map((f) => (
            <li key={f}>
              <button type="button" onMouseDown={() => { aoMudar(f); setAberto(false); }}
                className="w-full px-3 py-2 text-left text-sm hover:bg-muted flex items-center gap-2"><Truck className="w-3.5 h-3.5 text-muted-foreground" />{f}</button>
            </li>
          ))}
        </ul>
      )}
      {novo && !aberto && <p className="mt-1 text-xs text-muted-foreground">Fornecedor novo</p>}
    </div>
  );
}

// Faixa do topo: de quem comprou, quando e se já pagou.
export default function CabecalhoCompra({ c }) {
  return (
    <section className="rounded-xl border bg-card p-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1.3fr)_minmax(0,1fr)] items-start">
      <CampoFornecedor valor={c.fornecedor} aoMudar={c.setFornecedor} fornecedores={c.fornecedores} />
      <div>
        <label htmlFor="compra-data" className={rotulo}>Data da compra</label>
        <input id="compra-data" type="date" value={c.data} onChange={(e) => c.setData(e.target.value)} className={campo} />
      </div>
      <div>
        <span className={rotulo}>Pagamento</span>
        <label className={`mt-1 h-12 flex items-center justify-between gap-2 rounded-lg border px-3 cursor-pointer ${
          c.paga ? "bg-emerald-500/5 border-emerald-500/30" : "bg-amber-500/5 border-amber-500/30"}`}>
          <span className="flex items-center gap-2 text-sm font-semibold">
            {c.paga ? <CheckCircle2 className="w-4 h-4 text-emerald-600 dark:text-emerald-400" /> : <AlertCircle className="w-4 h-4 text-amber-600 dark:text-amber-400" />}
            {c.paga ? "Já está paga" : "Vou pagar depois"}
          </span>
          <Switch checked={c.paga} onCheckedChange={(v) => { c.setPaga(v); if (v) c.setVencimento(""); }} aria-label="Compra paga" />
        </label>
      </div>
      {!c.paga ? (
        <div>
          <label htmlFor="compra-vencimento" className={`${rotulo} flex items-center gap-1`}><Calendar className="w-3 h-3" /> Vencimento</label>
          <input id="compra-vencimento" type="date" value={c.vencimento} onChange={(e) => c.setVencimento(e.target.value)}
            className={`${campo} ${c.vencimento ? "" : "border-amber-500/60"}`} />
        </div>
      ) : <div className="hidden lg:block" />}
    </section>
  );
}
